'use client'
import {
  __spreadProps,
  __spreadValues
} from "./chunk-BTG5EALA.mjs";

// src/hooks/useCalendarQuery.ts
import { useMemo } from "react";
import { formatDate, splitDateTime } from "@wbk/utils";
import { useRouter } from "@wbk/config";
var MONTHS = {
  january: 0,
  february: 1,
  march: 2,
  april: 3,
  may: 4,
  june: 5,
  july: 6,
  august: 7,
  september: 8,
  october: 9,
  november: 10,
  december: 11
};
var useCalendarQuery = () => {
  const { search, setSearch } = useRouter();
  const query = useMemo(() => {
    let month = search.get("month") || "";
    let initialMonth = MONTHS[month];
    if (typeof initialMonth !== "number") {
      month = formatDate(/* @__PURE__ */ new Date(), "en", { month: "long" }).toLowerCase();
      initialMonth = MONTHS[month];
    }
    const year = (/* @__PURE__ */ new Date()).getFullYear();
    const totalDays = new Date(year, initialMonth + 1, 0).getDate();
    const days = Array.from({ length: totalDays }, (_, i) => {
      const date = new Date(year, initialMonth, i + 1);
      return {
        day: i + 1,
        date,
        dayKey: splitDateTime(date, "en", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit"
        }).date
      };
    });
    return {
      year,
      month,
      monthIndex: initialMonth,
      start: new Date(year, initialMonth, 1, 0, 0, 0),
      end: new Date(year, initialMonth + 1, 0, 23, 59, 59),
      days
    };
  }, [search]);
  const handleSelectMonth = (newMonth) => {
    const isYear = search.get("mode") === "yearly";
    if (isYear) {
      return setSearch({ mode: "list", month: newMonth });
    }
    const currentMode = search.get("mode") || "grid";
    if (query.month !== newMonth) {
      setSearch({ month: newMonth, mode: currentMode });
    }
  };
  return __spreadProps(__spreadValues({}, query), {
    months: MONTHS,
    selectMonth: handleSelectMonth
  });
};
var useCalendarQuery_default = useCalendarQuery;

export {
  useCalendarQuery_default
};
//# sourceMappingURL=chunk-PLJBED27.mjs.map